/**
 * Base Path Configuration
 * Handles dynamic base paths for deployment to subdirectories
 */

// Get the Vite base path from import.meta
export const getBasePath = (): string => {
  return import.meta.env.BASE_URL || '/'
}

// Get API base URL (can be different from app base path) — keep in sync with services/apiClient.ts
export const getApiBaseUrl = (): string => {
  if (import.meta.env.DEV) {
    return import.meta.env.VITE_API_BASE_URL || 'https://sakeena.life:4090/api'
  }
  return (
    (window as any).APP_CONFIG?.API_BASE_URL ||
    import.meta.env.VITE_API_BASE_URL ||
    'https://sakeena.life:4090/api'
  )
}

// Helper to resolve asset paths with base path
export const resolveAssetPath = (path: string): string => {
  const basePath = getBasePath()
  
  // Already absolute
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }
  
  // Starts with base path already
  if (path.startsWith(basePath)) {
    return path
  }
  
  // Remove leading slash if exists
  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  
  // Ensure base path ends with /
  const cleanBase = basePath.endsWith('/') ? basePath : `${basePath}/`
  
  return `${cleanBase}${cleanPath}`
}

// Helper for backend image URLs
export const getImageUrl = (imageUrl: string): string => {
  if (!imageUrl) return ''
  
  // Absolute URL
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl
  }
  
  // Frontend static assets (already handled by Vite)
  if (imageUrl.startsWith('/assets/')) {
    return resolveAssetPath(imageUrl)
  }
  
  const apiBaseUrl = getApiBaseUrl()
  const apiWithoutSuffix = apiBaseUrl.replace('/api', '')
  
  // Backend-relative URL
  if (imageUrl.startsWith('/')) {
    return `${apiWithoutSuffix}${imageUrl}`
  }
  
  // Just filename from backend images endpoint
  return `${apiWithoutSuffix}/api/images/${imageUrl}`
}

